var _excluded = ["className", "style", "full", "options", "onChange", "onClean", "onSelect", "value"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/* eslint react/no-array-index-key: 0 */
import React, { useState } from 'react';
import Downshift from 'downshift';
import { arrayOf, string, func, bool, shape } from 'prop-types';
import styled from 'styled-components';
import Input from '../../Input/web/Input';

var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
};

var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var full = _ref.full;
  return "width: " + (full ? '100%' : 'auto');
}, function (_ref2) {
  var isOpen = _ref2.isOpen,
      input = _ref2.theme.yoga.components.input;
  return isOpen ? "\n\n      " + Input + " {\n        border-color: " + input.border.color.typed + ";\n        border-bottom-width: 0;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n\n      fieldset {\n        border-color: " + input.border.color.typed + ";\n        border-bottom-width: 0;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n\n      label {\n        color: " + input.label.color.focus + ";\n        font-weight: " + input.label.font.weight + ";\n      }\n\n      legend {\n        font-weight: " + input.label.font.weight + ";\n      }\n      " : '';
});
var List = styled.ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  margin: 0;\n\n  padding: 0;\n\n  z-index: 999;\n\n  ", "\n"])), function (_ref3) {
  var full = _ref3.full,
      autocomplete = _ref3.theme.yoga.components.autocomplete;
  return "\n    top: " + autocomplete.height + "px;\n\n    width: " + (full ? '100%' : autocomplete.width + "px") + ";\n    max-height: " + autocomplete.height * 6 + "px;\n    box-sizing: border-box;\n\n    background-color: " + autocomplete.field.backgroundColor + ";\n\n    border-width: " + autocomplete.border.width + "px;\n    border-style: solid;\n    border-color: " + autocomplete.border.color.typed + ";\n\n    border-top-width: 0;\n    border-bottom-left-radius: " + autocomplete.border.radius + "px;\n    border-bottom-right-radius: " + autocomplete.border.radius + "px;\n\n    overflow: hidden;\n  ";
});
var Item = styled.li(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n\n  list-style: none;\n\n  cursor: pointer;\n\n  ", "\n"])), function (_ref4) {
  var selected = _ref4.selected,
      autocomplete = _ref4.theme.yoga.components.autocomplete;
  return "\n    padding:\n      " + autocomplete.list.padding.top + "px\n      " + autocomplete.list.padding.right + "px\n      " + autocomplete.list.padding.bottom + "px\n      " + autocomplete.list.padding.left + "px;\n\n    background-color: " + autocomplete.list.backgroundColor["default"] + ";\n    outline: none;\n\n    font-size: " + autocomplete.list.font.size + "px;\n    font-weight: " + autocomplete.list.font.weight["default"] + ";\n    line-height: " + autocomplete.list.font.lineHeight + "px;\n\n    &:hover {\n      background-color: " + autocomplete.list.backgroundColor.hover + ";\n    }\n\n    " + (selected ? "background-color: " + autocomplete.list.backgroundColor.hover + ";" : '') + "\n  ";
});
var Match = styled.mark(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  background: transparent;\n  color: inherit;\n\n  ", "\n"])), function (_ref5) {
  var autocomplete = _ref5.theme.yoga.components.autocomplete;
  return "\n    font-weight: " + autocomplete.list.font.weight.matched + ";\n  ";
});
/** The autocomplete is a normal input field enhanced by a panel of suggested options. */

var AutoComplete = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
      style = _ref6.style,
      full = _ref6.full,
      options = _ref6.options,
      onChange = _ref6.onChange,
      _onClean = _ref6.onClean,
      onSelect = _ref6.onSelect,
      value = _ref6.value,
      props = _objectWithoutPropertiesLoose(_ref6, _excluded);

  var _useState = useState(value),
      userValue = _useState[0],
      setUserValue = _useState[1];

  return /*#__PURE__*/React.createElement(Downshift, {
    selectedItem: userValue,
    onStateChange: function onStateChange(changes) {
      var selectedItem = changes.selectedItem,
          inputValue = changes.inputValue;

      if (selectedItem) {
        setUserValue(selectedItem);
        onSelect(selectedItem);
        onChange(selectedItem);
      } else if (Object.prototype.hasOwnProperty.call(changes, 'inputValue')) {
        setUserValue(inputValue);
        onChange(inputValue);
      }
    }
  }, function (_ref7) {
    var getInputProps = _ref7.getInputProps,
        getItemProps = _ref7.getItemProps,
        clearSelection = _ref7.clearSelection,
        getMenuProps = _ref7.getMenuProps,
        getRootProps = _ref7.getRootProps,
        highlightedIndex = _ref7.highlightedIndex,
        isOpen = _ref7.isOpen,
        openMenu = _ref7.openMenu,
        inputValue = _ref7.inputValue;
    var reg = new RegExp("(" + (escapeRegExp(inputValue || '').trim() || null) + ")", 'gi');
    var suggestionList = options.filter(function (option) {
      return option.match(reg);
    }).sort(function (first, second) {
      return first.toLowerCase().indexOf(inputValue) < second.toLowerCase().indexOf(inputValue) ? -1 : 1;
    }).slice(0, 6);
    var hasSuggestion = isOpen && Boolean(suggestionList.length);
    return /*#__PURE__*/React.createElement(Wrapper, _extends({
      className: className,
      style: style,
      full: full,
      isOpen: hasSuggestion
    }, getRootProps(), {
      ref: ref
    }), /*#__PURE__*/React.createElement(Input, _extends({}, props, {
      full: full,
      onClean: function onClean(cleanable) {
        _onClean(cleanable);

        clearSelection();
      }
    }, getInputProps({
      onFocus: function onFocus() {
        return inputValue.length ? openMenu() : null;
      }
    }))), hasSuggestion && /*#__PURE__*/React.createElement(List, _extends({}, getMenuProps(), {
      full: full
    }), suggestionList.map(function (option, optionIndex) {
      return /*#__PURE__*/React.createElement(Item, getItemProps({
        key: "" + option + optionIndex,
        index: optionIndex,
        item: option,
        selected: highlightedIndex === optionIndex
      }), option.split(reg).map(function (part, index) {
        return part.match(reg) ? /*#__PURE__*/React.createElement(Match, {
          key: index
        }, part) : /*#__PURE__*/React.createElement(React.Fragment, {
          key: "unmatch-" + index
        }, part);
      }));
    })));
  });
});
AutoComplete.propTypes = {
  className: string,
  full: bool,
  options: arrayOf(string),
  style: shape({}),

  /** callback to know when a user selects a suggestion */
  onSelect: func,

  /** called when user type or clean the field and when selects a suggestion */
  onChange: func,

  /** a callback to know when the user cleaned the field */
  onClean: func,
  value: string
};
AutoComplete.defaultProps = {
  className: undefined,
  full: false,
  options: [],
  style: undefined,
  onSelect: function onSelect() {},
  onChange: function onChange() {},
  onClean: function onClean() {},
  value: undefined
};
export default AutoComplete;